import { Card, Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiProdutor } from "pages/produtores/types/ApiProdutor";
import type { ApiRota } from "pages/rota/types/ApiRota";
import { formatDocument } from "std/format";

const { Title } = Typography;

export const columns: ColumnType<ApiProdutor>[] = [
	{
		dataIndex: "for_codigoindividual",
		key: "for_codigoindividual",
		title: "Cliente",
		render: (for_codigoindividual, row) => (
			<>
				{for_codigoindividual || ""} - {row?.pessoa?.pes_nome_razaosocial || ""}
			</>
		),
	},
	{
		dataIndex: ["pessoa", "pes_cnpj_cpf"],
		key: "pes_cnpj_cpf",
		title: "CNPJ/CPF",
		render: (pes_cnpj_cpf) => <>{formatDocument(pes_cnpj_cpf || "")}</>,
	},
	{
		dataIndex: "for_transferencia_tipo",
		key: "for_transferencia_tipo",
		title: "Tipo Conta",
		align: "center",
		render: (value) => {
			switch (value) {
				case 1:
					return "Nenhum";
				case 2:
					return "Pix";
				case 3:
					return "TED";
				default:
					return "Nenhum";
			}
		},
	},
	{
		dataIndex: "contaBancaria",
		key: "contaBancaria",
		title: "Dados de conta bancária",
		render: (_, record) => {
			if (record?.for_transferencia_tipo === 2 && record?.for_pix_chave_tipo !== 5) {
				switch (record?.for_pix_chave_tipo) {
					case 1:
						return `Chave Pix: ${record?.for_pix_chave || ""} (Telefone)`;
					case 2:
						return `Chave Pix: ${record?.for_pix_chave || ""} (E-mail)`;
					case 3:
						return `Chave Pix: ${record?.for_pix_chave || ""} (CPF/CNPJ)`;
					case 4:
						return `Chave Pix: ${record?.for_pix_chave || ""} (Chave aleatória)`;
					default:
						return "Chave Pix: Nenhum";
				}
			}

			return `Banco: ${record?.for_banco} - Agência: ${record?.for_agencia}${record?.for_agencia_dv ? `-${record?.for_agencia_dv}` : ""} - Conta: ${record?.for_conta}-${record?.for_conta_dv}`;
		},
	},
	{
		dataIndex: "pessoa",
		key: "cidade",
		title: "Cidade",
		render: (pessoa) => {
			let enderecoDefault = (pessoa?.endereco || []).find((end) => end.end_principal === 1);

			if (!enderecoDefault) {
				enderecoDefault = pessoa?.endereco ? pessoa?.endereco[0] : undefined;
			}

			return (
				<>
					{enderecoDefault?.cidade?.cid_uf || ""} - {enderecoDefault?.cidade?.cid_cidade || ""}
				</>
			);
		},
	},
];

export function TableRelCadastroProdutorSimp({ data, title }: { data: ApiRota[] | undefined; title: string }) {
	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{data &&
					data.length > 0 &&
					data.map((rota) => {
						return (
							<Card key={rota.rot_idpk}>
								<Title
									level={4}
									style={{
										margin: "0px",
										marginTop: "-8px",
										marginBottom: "8px",
									}}
								>
									Rota: {rota?.rot_idpk} - {rota?.rot_identificacao}
								</Title>

								<Title
									level={4}
									style={{
										margin: "0px",
										marginTop: "-8px",
										marginBottom: "8px",
									}}
								>
									Transportador: {rota?.transportador?.tra_codigoindividual} - {rota?.transportador?.pessoa?.pes_nome_razaosocial}
								</Title>

								<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
									<Table
										rowKey="for_idpk"
										columns={columns}
										dataSource={rota?.fornecedor || []}
										pagination={false}
										size="small"
										rowClassName="zebra"
									/>
								</Flex>
							</Card>
						);
					})}
			</Flex>
		</ImpressaoContainer>
	);
}
